<!-- <div class="announcement">
	this is an announcement
</div> -->

<div class="row text-center">
	<div class="col-sm-3">
		<eze-ring
			*ngFor="let ring of leftRings"
			[ring]="ring"
			[totalInColumn]="halfRings"
		></eze-ring>
	</div>
	<div class="col-sm-6">
		<div class="belt">
			<div class="belt-title color">
				Color Belt
			</div>
			<div class="belt-group">
				{{ billboard?.color }}
			</div>
		</div>

		<div class="announcement">
			<p>
				ez-events.com/live
			</p>
		</div>

		<div class="belt">
			<div class="belt-title">
				Black Belt
			</div>
			<div class="belt-group">
				{{ billboard?.black }}
			</div>
		</div>
	</div>
	<div class="col-sm-3">
		<eze-ring
			*ngFor="let ring of rightRings"
			[ring]="ring"
			[totalInColumn]="halfRings"
		></eze-ring>
	</div>
</div>
